import { render, staticRenderFns } from "./FilterCompanyProductCategoriesChild.vue?vue&type=template&id=5f05e4dc&"
import script from "./FilterCompanyProductCategoriesChild.vue?vue&type=script&lang=js&"
export * from "./FilterCompanyProductCategoriesChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports